/* eslint-disable @typescript-eslint/naming-convention */
import type { MantineThemeOverride } from '@mantine/core'

export const theme: MantineThemeOverride = {
  primaryColor: 'violet',
  fontFamily: 'Lato',
}
